import React from 'react';
import PropTypes from 'prop-types';
import { valueOrPlaceholder, isPresent } from 'helpers/string_helpers';
import PhoneList from '../phone_list';

export default class PersonBody extends React.Component {
  static propTypes = {
    record: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  }

  renderAddress() {
    const { record } = this.props;

    const addressThreeLine = (record.address || {}).threeLine;

    return (
      <div className="col-md-12">
        <div className="fw-bold">Office</div>
        <div className="text-truncate">
          {isPresent(addressThreeLine) ?
            <>
              {isPresent(addressThreeLine[0]) && <div>{addressThreeLine[0]}</div>}
              {isPresent(addressThreeLine[1]) && <div>{addressThreeLine[1]}</div>}
              {isPresent(addressThreeLine[2]) && <div>{addressThreeLine[2]}</div>}
            </>
            : <div>
              {valueOrPlaceholder(addressThreeLine)}
            </div>
          }
        </div>
      </div>
    );
  }

  renderPhoneNumbers() {
    const { record: { name, phoneNumbers }, user } = this.props;
    if (phoneNumbers.length === 0) return;

    return (
      <div className="col-md-12">
        <div className="fw-bold">Phone</div>
        <div className="text-truncate">
          <PhoneList name={name} phoneNumbers={phoneNumbers} user={user}/>
        </div>
      </div>
    );
  }

  render() {
    const { record } = this.props;
    return (
      <div className="px-6 py-4">
        <div className="row gy-2">
          <div className="col-md-12">
            <div className="fw-bold">Website</div>
            <div className="text-truncate">
              {isPresent(record.url) ?
                <a href={record.url}>{valueOrPlaceholder(record.url)}</a>
                : <span>{valueOrPlaceholder(record.url)}</span>
              }
            </div>
          </div>
          {this.renderPhoneNumbers()}
          <div className="col-md-12">
            <div className="fw-bold">Email</div>
            <div className="text-truncate">
              {valueOrPlaceholder(record.email)}
            </div>
          </div>
          {this.renderAddress()}
          <div className="col-md-12">
            <div className="fw-bold">Company Industry</div>
            <div className="text-truncate">
              {valueOrPlaceholder(record.industry)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

